import React from 'react';
import { func_datetime, func_validation, isNotNullUndefined, isStringTrimNotEmpty } from 'functions';
import { Tooltip } from 'components/informational/Tooltip';
import { convertMonthYearToISO } from './func_custom';
import Toggle from 'components/buttons/Toggle';

export function useOutletTableColumns() {

    function getColumn_outletName() {
        let columnClassName = "columns__outletName";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Outlet Name",
            id: "chargeValue",
            accessor: "chargeValue",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"msg__content noWrap-text-ellipsis"}
                        target={value_formatted}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 200
        }
    }

    function getColumn_category() {
        let columnClassName = "columns__category";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Category",
            id: "category",
            accessor: "category",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"msg__content noWrap-text-ellipsis"}
                        target={value_formatted}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 200
        }
    }

    function getColumn_status() {
        let columnClassName = "columns__status";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Status",
            id: "hasApplied",
            accessor: "hasApplied",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let data = props?.row?.original;

                let rowIndex = props?.row?.index;
                let colId = props?.column?.id;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        <Toggle 
                            isActiveInit={value}
                            onToggle={(active) => props.onChangeStatus(rowIndex, colId, active, data)} 
                        />
                    </div>
                );
            },
            width: 200
        }
    }

    function getColumn_planNum() {
        let columnClassName = "columns__planNum";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Plan No",
            id: "appliedPlanNo",
            accessor: "appliedPlanNo",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"msg__content noWrap-text-ellipsis"}
                        target={value_formatted}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 200
        }
    }

    function getColumn_startDate() {
        let columnClassName = "columns__startDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Start Date",
            id: "startDate",
            accessor: "startDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
                let rowIndex = props?.row?.index;
                let colId = props?.column?.id;
                let endDate = props?.data[rowIndex]?.endDate
                let maxDate = isNotNullUndefined(endDate)? convertMonthYearToISO(endDate):""

                const handleChange = (e) => {
                    props.updateDate(rowIndex, colId, e.target.value)
                }
    
                return (
                    <input type="month" defaultValue={convertMonthYearToISO(value_formatted)} max={maxDate} onChange={handleChange} />
                );
            },
            width: 200
        }
    }

    function getColumn_endDate() {
        let columnClassName = "columns__endDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "End Date",
            id: "endDate",
            accessor: "endDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
                let rowIndex = props?.row?.index;
                let colId = props?.column?.id;
                let startDate = props?.data[rowIndex]?.startDate
                let minDate = isNotNullUndefined(startDate)? convertMonthYearToISO(startDate):""

                const handleChange = (e) => {
                    props.updateDate(rowIndex, colId, e.target.value)
                }
    
                return (
                    <input type="month" defaultValue={convertMonthYearToISO(value_formatted)} min={minDate} onChange={handleChange} />
                );
            },
            width: 200
        }
    }
    
    function getColumn_quotationReminder() {
        let columnClassName = "columns__quotationReminder";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Quotation Reminder",
            id: "quotationReminder",
            accessor: "quotationReminder",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;

                let rowIndex = props?.row?.index;
                let colId = props?.column?.id;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        <Toggle 
                            isActiveInit={value}
                            onToggle={(active) => props.onChangeQuotationReminder(rowIndex, colId, active)} 
                        />
                    </div>
                );
            },
            width: 200
        }
    }

    return {
        invoicesCol: [
            getColumn_outletName(),
            getColumn_category(),
            getColumn_status(),
            getColumn_planNum(),
            getColumn_startDate(),
            getColumn_endDate(),
            getColumn_quotationReminder()
        ]
    }
}